import { ClaimOrderPositionModel } from "./ClaimOrderPositionModel";

export class ClaimOrderModel {
    constructor(orderGroupId: string) {
        this.orderGroupId = orderGroupId;
    }

    orderGroupId: string;
    claimOrderPositions: ClaimOrderPositionModel[] = [];
}